export default __webpack_public_path__ + "static/media/Icon material-content-copy.46c2fcbb.svg";